// hooks/useCreateNewReservation.ts
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store"; // Adjust the import based on your file structure
import moment from "moment";
import { CreateVenueReservationData } from "../../api/types";
import Logger from "../helpers/logger";
import ErrorTracker from "../helpers/errorTracker";
import { useVenueCreateNewReservationMutation } from "../../api/reservations/reservationsApiSlice";
import { processReservationData } from "./processors";
import { reservationCreated } from "../slice/bookingCreation/bookingCreationSlice";
import { PersonalData } from "../../types/bookingCreation";
import KolulaStorageManager from "../../storage/KolulaStorageManager";
import { setVenueReservationSuccess } from "../slice/apartmentRental/apartmentRentalSlice";
import { setTimeOnDate } from "../../util";

export const useCreateNewReservation = (useCase?: string) => {
  const indexDBStore = new KolulaStorageManager();
  const assetGroupSelection = useSelector(
    (state: RootState) => state.bookingCreation.assetGroupId
  );
  const orderData = useSelector(
    (state: RootState) => state.bookingCreation.orderData
  );
  const personalData: PersonalData = useSelector(
    (state: RootState) => state.bookingCreation.personalData
  );
  const totalPrice = useSelector(
    (state: RootState) => state.bookingCreation.totalPrice
  );
  const startTime = useSelector(
    (state: RootState) => state.bookingCreation.orderData.startTime
  );
  const endTime = useSelector(
    (state: RootState) => state.bookingCreation.orderData.endTime
  );

  console.log();

  const [createNewReservationMutation] = useVenueCreateNewReservationMutation();
  const dispatch = useDispatch();

  const createNewReservation = async () => {
    try {
      if (!assetGroupSelection || !orderData) {
        return;
      }

      let fromDate;
      let toDate;
      if (orderData.checkInDate && orderData.checkOutDate) {
        fromDate = orderData.checkInDate.toISOString();
        toDate = orderData.checkOutDate.toISOString();
      } else {
        if (orderData.time) {
          fromDate = moment(
            `${orderData.date!.format("YYYY-MM-DD")} ${orderData.time}`,
            "YYYY-MM-DD HH:mm"
          );
        } else {
          fromDate = moment(orderData.date!).startOf("day");
        }

        toDate = fromDate.clone().add(orderData.duration, "minutes");
        fromDate = fromDate.toISOString();
        if (orderData.time !== "00:00") {
          toDate = toDate.toISOString();
        } else {
          toDate = toDate.subtract(1, "days").toISOString();
        }
      }

      const newReservation: CreateVenueReservationData = {
        reservation: {
          amount: orderData.amount,
          groupId: assetGroupSelection,
          fromDate: setTimeOnDate(fromDate, startTime!),
          toDate: setTimeOnDate(toDate, endTime!),
          guests: orderData.numberOfGuests, // Use the selected number of guests
          price: totalPrice, // Use the total price from the booking creation slice
        },
        service: "venue",
        eventType: orderData.eventType!,
        contactData: {
          firstname: personalData.firstName,
          lastname: personalData.lastName,
          email: personalData.email,
          telephone: personalData.phone,
          company: personalData.company,
          address: personalData.address,
          zipCode: personalData.zipCode,
          city: personalData.city,
          country: personalData.country,
        },
      };

      // Call the mutation function
      const response = await createNewReservationMutation(
        newReservation
      ).unwrap();

      if (response.id) {
        await indexDBStore.insertInternalMultipleOrdersIds([response.id]);
        dispatch(setVenueReservationSuccess(5));
      }
      localStorage.setItem("new_reservation", JSON.stringify(response));

      const processedReservation = processReservationData(response);
      if (processedReservation) {
        dispatch(reservationCreated({ reservation: processedReservation }));
      }
      return processedReservation;
    } catch (error) {
      Logger.for("createNewReservation").error(error);
      ErrorTracker.trackException(error as Error);
    }
  };

  return createNewReservation;
};
